// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__2KfKS","title":"Sidebar_title__8IZPp","list":"Sidebar_list__Lk0qW","list_item":"Sidebar_list_item__mCEp8"};